import React, { useEffect, useState } from "react";
import Tabs from "components/lib/Shared/Tabs";
import ApprovalDocuments from "./ApprovalDocument";

const Approvals = (props) => {
  const { transactions, officialIndex, actionType, documents } = props;
  const initialTabs = React.useMemo(() => {
    if (!transactions.length) return [];
    const conditions = [
      {
        key: "director_approval",
        label: "Director Approval",
        type: "boardApproval",
      },
      {
        key: "shareholder_approval",
        label: "Shareholder Approval",
        type: "shareholderApproval",
      },
      {
        key: "gazette_approval",
        label: "Gazette Notice",
        type: "gazetteNotice",
      },
      {
        key: "creditors_appointment",
        label: "Creditors Resolution",
        type: "creditorsResolution",
      },
      {
        key: "court_order_appointment",
        label: "Court Order",
        type: "courtOrder",
      },
    ];

    let filteredConditions = conditions.filter(({ type }) =>
      transactions.some((transaction) => {
        return !transaction.approvalType || transaction.approvalType === type;
      })
    );
    let foundShareholderApproval = filteredConditions.find(
      (elm) => elm.type === "shareholderApproval"
    );
    let foundDirectorApproval = filteredConditions.find(
      (elm) => elm.type === "boardApproval"
    );

    if (foundShareholderApproval && !foundDirectorApproval) {
      filteredConditions.push({
        key: "director_approval",
        label: "Director Approval",
        type: "boardApproval",
      });
    }
    let mappedConditions = filteredConditions.map(({ key, label }) => ({
      id: key,
      label,
    }));
    return mappedConditions;
  }, [transactions]);
  const [tabs, setTabs] = useState(initialTabs);
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  useEffect(() => {
    setSelectedTab(tabs[selectedTabIndex]);
  }, [selectedTabIndex]);

  const generateFileUploads = (transactions) => {
    let filesUploads = {};
    transactions.forEach((trx) => {
      if (
        trx?.directorApprovalDocs &&
        !Object.keys(filesUploads).includes("directorApprovalDocs")
      ) {
        filesUploads.directorApprovalDocs = trx.directorApprovalDocs.fileName;
      }
      if (
        trx?.courtOrderApprovalDocs &&
        !Object.keys(filesUploads).includes("courtOrderApprovalDocs")
      ) {
        filesUploads.courtOrderApprovalDocs =
          trx.courtOrderApprovalDocs.fileName;
      }
      if (
        trx?.shareholderApprovalDocs &&
        !Object.keys(filesUploads).includes("shareholderApprovalDocs")
      ) {
        filesUploads.shareholderApprovalDocs =
          trx.shareholderApprovalDocs.fileName;
      }
      if (
        trx?.gazetteApprovalDocs &&
        !Object.keys(filesUploads).includes("gazetteApprovalDocs")
      ) {
        filesUploads.gazetteApprovalDocs = trx.gazetteApprovalDocs.fileName;
      }
      if (
        trx?.creditorApprovalDocs &&
        !Object.keys(filesUploads).includes("creditorApprovalDocs")
      ) {
        filesUploads.creditorApprovalDocs = trx.creditorApprovalDocs.fileName;
      }
    });
    return filesUploads;
  };

  const fileUploads = generateFileUploads(transactions);
  return (
    <div>
      <h1>Approvals</h1>
      {
        <Tabs
          tabs={initialTabs}
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
        />
      }
      <div>
        {selectedTab.id === "director_approval" && (
          <ApprovalDocuments
            officialIndex={officialIndex}
            selectedTab="Director"
            fileUploads={fileUploads}
            documentData={documents.find((doc) => doc.type === "Director")}
            documentType="directorApprovalDocs"
            actionType={actionType}
          />
        )}
        {selectedTab.id === "court_order_appointmen" && (
          <ApprovalDocuments
            officialIndex={officialIndex}
            selectedTab="Court Order"
            documentData={documents.find((doc) => doc.type === "CourtOrder")}
            documentType="courtOrderApprovalDocs"
            actionType={actionType}
            fileUploads={fileUploads}
          />
        )}
        {selectedTab.id === "shareholder_approval" && (
          <ApprovalDocuments
            officialIndex={officialIndex}
            selectedTab="Shareholder"
            documentData={documents.find((doc) => doc.type === "Shareholder")}
            documentType="shareholderApprovalDocs"
            actionType={actionType}
            fileUploads={fileUploads}
          />
        )}
        {selectedTab.id === "gazette_approval" && (
          <ApprovalDocuments
            officialIndex={officialIndex}
            selectedTab="Court Order"
            documentData={documents.find((doc) => doc.type === "GazetteNotice")}
            documentType="gazetteApprovalDocs"
            actionType={actionType}
            fileUploads={fileUploads}
          />
        )}
        {selectedTab.id === "creditors_appointment" && (
          <ApprovalDocuments
            officialIndex={officialIndex}
            selectedTab="Creditor"
            documentData={documents.find((doc) => doc.type === "Creditor")}
            documentType="creditorApprovalDocs"
            actionType={actionType}
            fileUploads={fileUploads}
          />
        )}
      </div>
    </div>
  );
};

export default Approvals;
